import { monitoringRuleChanges, type MonitoringRuleLike } from '@norvix/utils';

import type { PendingChange } from './settings-changes';

/**
 * What a transaction-monitoring draft is about to change, for the save bar
 * (DEV-137). The same comparison the API records in the History; a rule
 * switched off, or an enabled rule removed, needs a reason, which the API
 * enforces too (REASON_REQUIRED).
 */

/** The shortest reason the monitoring API accepts. */
export const MONITORING_REASON_MIN = 10;

export function monitoringPendingChanges(
  saved: readonly MonitoringRuleLike[],
  edited: readonly MonitoringRuleLike[],
): PendingChange[] {
  const next = new Map(edited.map((rule) => [rule.id, rule]));
  const switchedOff = new Set(saved.filter((rule) => rule.enabled && next.get(rule.id)?.enabled !== true).map((rule) => rule.id));
  return monitoringRuleChanges(saved, edited).map((change) => {
    const id = change.key.replace(/^rule:/, '').replace(/:enabled$/, '');
    const stopsScreening = switchedOff.has(id) && (change.key.endsWith(':enabled') || change.after === null);
    return { ...change, secret: false, needsReason: stopsScreening };
  });
}
